'use client';

interface EmptyStateProps {
  onCreate: () => void;
  busy: boolean;
}

export function EmptyState({ onCreate, busy }: EmptyStateProps) {
  return (
    <div className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-5 px-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl">
        <svg
          className="h-7 w-7 text-brand-400"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m10 9 5 3-5 3V9z" />
        </svg>
      </div>

      <div className="space-y-2">
        <h2 className="text-2xl font-semibold text-white">Пока нет проектов</h2>
        <p className="mx-auto max-w-sm text-sm leading-relaxed text-white/50">
          Создайте первый проект, чтобы собрать рекламный ролик из клипов, музыки и текста.
        </p>
      </div>

      <button
        type="button"
        onClick={onCreate}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-xl bg-brand-600 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-brand-600/30 transition hover:bg-brand-500 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {busy ? 'Создаём…' : '+ Создать проект'}
      </button>
    </div>
  );
}
